"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callWindowCybertronics = void 0;
var methods_to_call_1 = require("../_utils/methods-to-call");
var callWindowCybertronics = function (call) {
    // NOTE: for SSR Gatsby
    if (typeof window === "undefined") {
        return;
    }
    var callMethod = function () {
        try {
            call();
        }
        catch (e) {
            console.error("window.AFCYBERTONICA call failed");
            console.error(e);
        }
    };
    // Если скрипт еще не прогрузился, сохраняем в массив и выполним как только загрузится скрипт
    if (!window.AFCYBERTONICA) {
        console.log("delay call to window.AFCYBERTONICA");
        methods_to_call_1.cybertronicsMethods.addMethodToCall(callMethod);
        return;
    }
    callMethod();
};
exports.callWindowCybertronics = callWindowCybertronics;
//# sourceMappingURL=call-window-cybertronics.js.map